<template>
  <v-container class="sero-survey-complete-page">
    <v-row justify="center">
      <v-col cols="12" lg="12" xl="8">
        <v-card class="elevation-2 card-empty" color="primary">
          <v-list-item one-line class="pt-1">
            <v-list-item-content>
              <v-list-item-title class="subtitle-1 mb-1 white--text text--darken-2 font-weight-bold">
                <v-icon left color="white">mdi-clipboard-list-outline</v-icon>
                {{ translate($store.getters.content.survey_title) }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-card-text class="bg-white text-area pt-12 pl-10 pr-10 pb-16" height="400">
            <v-alert dense text type="success">
              {{ translate($store.getters.content.form_submitted) }}
            </v-alert>

            <div class="float-right">
              <v-btn large @click="startPage()" depressed color="primary">
                {{ translate($store.getters.content.go_home) }}
              </v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import SharedFunctions from '@/mixins/SharedFunctions.vue';

export default {
  mixins: [SharedFunctions],
  components: {},
  data() {
    return {};
  },
  methods: {
    startPage() {
      this.$router.push({ name: 'Home' });
    }
  }
};
</script>

<style></style>
